import React from 'react';
import { Button, Checkbox, notification, Form, type FormProps, Input, Card, Select, DatePicker, Upload } from 'antd';
import { RewardService } from "./../../services/RewardService";
import moment from 'moment';
import dayjs from 'dayjs';
import {
    UploadOutlined
} from "@ant-design/icons";

interface Props {
    record: any
    onFinish: () => void
}

export default function Create(props: Props) {

    const [form] = Form.useForm();
    const [file, setFile] = React.useState<any>();

    const handleFileChange = (info: any) => {
        const uploadedFile = info.file;
        setFile(uploadedFile);
    };

    React.useEffect(() => {
        setFile(null)
        form.resetFields();
        form.setFieldsValue({
            ...props?.record,
            'expired_date': props?.record?.expired_date && moment(props?.record?.expired_date).isValid() ? dayjs(props?.record?.expired_date) : undefined
        })
    }, [props?.record])


    const onFinish: FormProps["onFinish"] = async (values) => {


        const formData = new FormData();
        formData.append('name_th', values.name_th);
        formData.append('name_en', values.name_en);
        formData.append('is_public', values.is_public ? "1" : "0");
        formData.append('reward_category', file);

        if (props?.record?.id) {
            var res = await RewardService.updateCategory(formData, props.record.id)
        } else {
            var res = await RewardService.saveCategory(formData)
            form.resetFields();
        }

        if (res.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            if (!props?.record?.id) {
                form.resetFields();
            }
            props.onFinish();
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    };

    const onFinishFailed: FormProps["onFinishFailed"] = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };


    return (
        <Card
            bordered={false}>

            <Form
                name="basic"
                form={form}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ maxWidth: 600 }}
                initialValues={{ name_th: '', name_en: '', type: '', url_link: '', is_public: 0, is_affiliate: 0 }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <Form.Item
                    label="Upload Photo"
                    name="photo"
                    extra="Size limit  10 MB."
                >
                    <Upload
                        beforeUpload={() => false} // Prevent auto upload
                        onChange={handleFileChange}
                        maxCount={1}
                        accept="image/*"
                    >
                        <Button icon={<UploadOutlined />}>Click to Upload</Button>
                    </Upload>
                </Form.Item>

                <Form.Item
                    label="Category Name (TH)"
                    name="name_th"
                    rules={[{ required: true, message: 'Please fill banner name' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Category Name (EN)"
                    name="name_en"
                    rules={[{ required: true, message: 'Please fill banner name' }]}
                >
                    <Input />
                </Form.Item>


                <Form.Item
                    label="Is Public"
                    name="is_public"
                    valuePropName="checked"
                    rules={[{ required: true, message: 'Please fill Is Public' }]}
                >
                    <Checkbox  >Public</Checkbox>
                </Form.Item>





                <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                    <Button type="primary" htmlType="submit">
                        {props.record?.id ? 'อัพเดต' : 'บันทึก'}
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
}
